import { createSlice } from '@reduxjs/toolkit';
import { userApi } from '@/store/api/userApi';
import { WalletItem } from '@/types/user';

interface WalletInfo {
  mainBalance: number;
  bonusBalance: number;
  exposure: number;
  lockedAmount: number;
}

const initialState: WalletInfo = {
  mainBalance: 0,
  bonusBalance: 0,
  exposure: 0,
  lockedAmount: 0,
};

const walletSlice = createSlice({
  name: 'wallet',
  initialState,
  reducers: {
    resetWallet: () => initialState,
  },
  extraReducers: (builder) => {
    builder.addMatcher(userApi.endpoints.getUserWallets.matchFulfilled, (state, { payload }) => {
      const balance = {
        mainBalance: 0,
        bonusBalance: 0,
        exposure: 0,
        lockedAmount: 0,
      };

      Array.isArray(payload) &&
        payload?.forEach((w: WalletItem) => {
          const type = w?.type ? w?.type?.toLowerCase() : '';
          if (type === 'main') {
            balance.mainBalance = Number(w.amount);
            balance.exposure = Number(w.exposureAmount);
            balance.lockedAmount = Number(w.lockedAmount);
          } else if (type === 'bonus') {
            balance.bonusBalance = Number(w.amount);
          }
        });

      return balance;
    });
  },
});

export const { resetWallet } = walletSlice.actions;
export default walletSlice.reducer;
